module.exports = {
	"it": {
		"static-pages": {
			"notFound": {
				"pageTitle": "Pagina non trovata",
				"title": "Non trovata",
				"details": "L’applicazione cercata non è stata trovata, hai scritto l’indirizzo correttamente?",
				"goBack": "Indietro"
			},
			"activation": {
				"pageTitle": "Zona sicura",
				"title": "Ti diamo il benvenuto alla zona sicura",
				"activate": {
					"details": "Un secondo, stiamo preparando il link di attivazione…",
					"ready": "Il link è pronto, basta cliccare sul bottone per procedere. Nota: questo link è utilizzabile una volta sola!",
					"go": "Attiva account"
				},
				"passwordReset": {
					"details": "Un secondo, stiamo preparando il link di ripristino della password…",
					"ready": "Il link è pronto, basta cliccare sul bottone per procedere. Nota: questo link è utilizzabile una volta sola!",
					"go": "Ripristina password"
				},
				"error": {
					"details": "Pare che qualcosa non funzioni con questo link. Riprova o contatta il supporto, fornendo il codice di riferimento."
				}
			},
			"privacy-policy": {
				"pageTitle": "Politica sulla privacy del Portale Merchant"
			},
			"terms-and-conditions": {
				"pageTitle": "Accordo Portale Merchant"
			},
			"Support": {
				"pageTitle": "Supporto",
				"topic": {
					"orders": "Ordini",
					"settlements": "Liquidazioni",
					"agreements": "Accordi",
					"technical_issues": "Problemi tecnici",
					"others": "Altri"
				},
				"TicketList": {
					"title": "Richieste di supporto",
					"pageDescription": "Qui puoi vedere lo stato delle tue richieste di supporto",
					"status": {
						"open": "Apri",
						"pending": "In attesa di pagamento",
						"resolved": "Risolti",
						"closed": "Chiusi",
						"inProgress": "In corso",
						"waitingForYourReply": "In attesa della tua risposta"
					},
					"TicketTable": {
						"id": "Richiesta n.",
						"mid": "Negozio/MID",
						"subject": "Oggetto",
						"status": "Stato",
						"updatedAt": "Ultimo aggiornamento"
					}
				},
				"EmptyTicketList": {
					"title": "Non hai alcuna richiesta aperta"
				},
				"ticketDetails": {
					"sidebar": {
						"user": {
							"title": "Utente"
						},
						"details": {
							"title": "Dettagli",
							"store": "Negozio/MID",
							"createdAt": "Richiedi data",
							"updatedAt": "Ultimo aggiornamento"
						},
						"actions": {
							"close": "Chiudi richiesta",
							"reopen": "Riapri richiesta"
						},
						"closeTicketDialog": {
							"confirm": "Conferma",
							"title": "Chiudi richiesta",
							"description": "Stai per chiudere questa richiesta. Potrai riaprirla solamente entro i prossimi 7 giorni.",
							"error": "Oh no! Si è verificato un problema, riprova un’altra volta."
						},
						"reopenTicketDialog": {
							"title": "Riapri richiesta",
							"description": "Spiegaci meglio perché hai bisogno di riaprire questa richiesta e ti risponderemo al più presto.",
							"messageLabel": "Messaggio"
						}
					},
					"conversation": {
						"loadMore": "Carica altre",
						"title": "Richiesta",
						"attachments": {
							"label": "Allegati"
						},
						"reply": {
							"title": "Aggiungi risposta",
							"body": {
								"label": "Aggiungi una risposta",
								"error": null
							},
							"attachment": {
								"label": "Aggiungi allegati",
								"error": "La dimensione totale dei file non può eccedere i 15 MB"
							},
							"add": "Aggiungi risposta",
							"cancel": "Annulla",
							"submit": {
								"label": "Invia",
								"error": "Si è verificato un errore nel salvare la risposta, riprova più tardi"
							}
						}
					}
				},
				"errorView": {
					"429": {
						"title": "Oh, no!",
						"message": "Oh, no! Si è verificato un problema, riprova in alcuni minuti. Se il problema persiste, contattaci per richiedere assistenza.",
						"contact": "Quando contatti il supporto fornisci il seguente ID di correlazione",
						"action": "Contattaci"
					},
					"error": "Errore",
					"default": {
						"title": "Spiacenti, si è verificato un problema",
						"message": "Per qualche ragione da parte nostra,non ci è stato possibile eseguire la tua richiesta. Puoi riprovare un’altra volta o tornare più tardi.",
						"contact": "Quando contatti il supporto fornisci il seguente ID di correlazione",
						"action": "Aggiorna"
					}
				}
			},
			"Marketing": {
				"pageTitle": "Marketing Grab and Go",
				"banner": {
					"title": "Ti diamo il benvenuto al marketing Grab and Go!",
					"subtitle": "Qui sarà possibile trovare le risorse pronte all’uso per il sito, per le campagne email e per il marketing sui social media.",
					"button": "Maggiori informazioni"
				},
				"productSection": {
					"title": "Quale prodotto Klarna offrite ai clienti?"
				},
				"MarketSelector": {
					"label": "Seleziona mercato",
					"markets": {
						"BE": "Belgio (olandese)",
						"BE-FR": "Belgio (francese)"
					}
				},
				"ChannelSelector": {
					"pageTitle": {
						"kco": "Checkout Klarna",
						"fourInstallments": "4 rate",
						"pin30": "Paga in 30 giorni"
					}
				},
				"sourceAndPreview": {
					"helpButton": "Hai bisogno di aiuto?",
					"copyButton": "Copia negli appunti",
					"copyButtonSuccess": "Copiato!",
					"sourceButton": "Sorgente",
					"previewButton": "Anteprima"
				},
				"EmailTemplates": {
					"pageTitle": "Modelli di email",
					"title": "Modelli di email"
				},
				"EmailHeader": {
					"pageTitle": "Immagine email marketing",
					"title": "Immagine email marketing"
				},
				"Social": {
					"pageTitle": "Social media",
					"title": "Social media"
				},
				"buttonDownload": "Scarica immagine",
				"buttonCopy": "Copia testo",
				"buttonCopySuccess": "Copiato!",
				"missingPreview": "Anteprima mancante",
				"productLinkText": "Acquisire risorse",
				"content": {
					"products": {
						"kco": {
							"title": "Checkout Klarna",
							"subtitle": "Una completa soluzione di checkout con tutto in un unico posto."
						},
						"payNow": {
							"title": "Paga ora",
							"subtitle": "Permetti ai tuoi clienti di pagare subito il loro acquisto."
						},
						"threeInstallments": {
							"title": "3 rate",
							"subtitle": "Per dare ai clienti la libertà di dilazionare il costo nel tempo a interessi zero."
						},
						"fourInstallments": {
							"title": "4 rate",
							"subtitle": "Per dare ai clienti la libertà di dilazionare il costo nel tempo a interessi zero."
						},
						"pin14": {
							"title": "Paga in 14 giorni",
							"subtitle": "Paga in 14 giorni. Nessun interesse o commissioni aggiunte."
						},
						"pin21": {
							"title": "Paga in 21 giorni",
							"subtitle": "Paga in 21 giorni. Nessun interesse o commissioni aggiunte."
						},
						"pin30": {
							"title": "Paga in 30 giorni",
							"subtitle": "Paga in 30 giorni. Nessun interesse o commissioni aggiunte."
						},
						"financing": {
							"title": "Finanziamento",
							"subtitle": "È possibile aumentare le proprie vendite offrendo ai clienti fino a 36 mesi per pagare."
						}
					},
					"campaigns": {
						"holidays-2020": {
							"title": "Vacanze 2020",
							"channels": {
								"emailHeader": {
									"title": "Immagine email marketing",
									"subtitle": "Fai in modo che gli iscritti alle tue email siano veramente interessati durante la stagione delle vacanze invernali con queste immagini professionali.",
									"linkText": "Visualizza immagini",
									"introduction": "È il momento di far conoscere ai tuoi iscritti le tue fantastiche offerte e gli sconti per le vacanze invernali. Scarica un’immagine e aggiungila alla tua campagna email o all’intestazione del modello di email per ottenere il massimo impatto."
								},
								"social": {
									"title": "Social media",
									"subtitle": "Indirizza più clienti al tuo negozio durante le vacanze invernali con queste foto utilizzabili gratuitamente.",
									"linkText": "Visualizza i post",
									"introduction": "È giunto il momento di annunciare al mondo le tue fantastiche offerte e sconti per le vacanze invernali! Scarica semplicemente le risorse e caricale sui tuoi profili nei social media o sul tuo strumento di pianificazione. Ricordati di taggare {link} su Instagram per raggiungere ancora più acquirenti e conversioni."
								}
							},
							"imageAlt": {
								"holiday1": "Persona in un body blu,  argento e rosa su un ginocchio davanti a uno spazzolone; con un braccio teso sposta una scarpa d’argento e con l’altro tiene in mano uno smartphone.",
								"holiday2": "Persona in pigiama di raso bordeaux che siede a gambe incrociate, levitando sopra a due ventilatori con uno smartphone che galleggia all’altezza del suo sguardo."
							}
						},
						"at-launch": {
							"title": "Al lancio",
							"subtitle": "Hai appena cominciato il viaggio con noi? Utilizza queste risorse per informare gli acquirenti, nuovi e vecchi, che ora la tua attività collabora con Klarna.",
							"channels": {
								"email": {
									"title": "Modelli di email",
									"subtitle": "Permetti ai tuoi abbonati di sapere che c’è un nuovo modo di pagare al checkout.",
									"linkText": "Visualizza i modelli",
									"introduction": "È il momento di annunciare ai tuoi abbonati che il tuo lancio con Klarna è stato effettuato! Semplicemente copia e incolla il modello o il contenuto nella propria piattaforma email, e il gioco è fatto.",
									"codeBoxTitle": "Email di lancio"
								},
								"social": {
									"title": "Social media",
									"subtitle": "Indirizza più clienti al tuo negozio con queste foto smoooth professionali.",
									"linkText": "Visualizza i post",
									"introduction": "È giunto il momento di annunciare al mondo il tuo lancio con Klarna! Scarica semplicemente le risorse e caricale sui tuoi profili nei social media o sul tuo strumento di pianificazione. Ricordati di taggare {link} nei tuoi post per raggiungere ancora più acquirenti."
								},
								"osm": {
									"title": "Pagine di destinazione",
									"subtitle": "Rimani in regola e informa gli acquirenti su come fare acquisti con Klarna.",
									"linkText": "Viusalizza pagine"
								}
							},
							"imageAlt": {
								"emotional": "Persona con i capelli lunghi e ricci in tuta da ginnastica viola che gioca a flipper",
								"paymentShowcase": "Una mano che regge un telefono che mostra il logo Klarna, pattini a rotelle sullo sfondo",
								"simplified": "Telefono rivolto verso il basso su un flipper cromato a destra, divano giallo acceso a sinistra",
								"device": "Un telefono che mostra il logo Klarna, in una stanza rosa con lampadario sullo sfondo"
							}
						}
					}
				}
			}
		}
	}
};